import type { DocumentV1 } from '@alpod-ai-writer/backend';
import type { IdentitySnippet } from '@alpod-ai-writer/backend/src/schemas/identity/identitySnippet.schema';
import type { CursorData, DocumentTemplate } from '@alpod-ai-writer/shared';
import type { HocuspocusProvider } from '@hocuspocus/provider';
import { createContext } from 'react';

export interface DocumentEditorContext {
    document: DocumentV1.Record,
    template: DocumentTemplate;
    yjsProvider: HocuspocusProvider;
    currentRevisionId: string;
    cursorData: CursorData;
    readOnly: boolean;
    isUnlocked: boolean;
    requestHelp: (fields?: Record<string, string>) => void;
    resolveUserIdentity(identityId: string): IdentitySnippet|null;
}

export const DocumentEditorContext = createContext<DocumentEditorContext>({} as DocumentEditorContext);
